<template>
  <div id="app">
    <div class="page-wrapper">
      <div class="container">
        <h1 class="title">开心果短剧（PistyTV）隐私政策</h1>
        <p>最后更新：2026年10月26日</p>
        <p>
          开心果短剧（PistyTV）由 Magicube Group Co.,
          Limited（“我们”）运营。我们致力于保护开心果短剧（PistyTV）用户（“用户”或“您”）的隐私。本隐私政策（“本政策”）描述了我们如何收集、存储、使用和管理信息，包括您提供的个人信息，以及我们通过与本政策链接的网站（例如：https://cubetv.cc/comic-series-privacy）或开心果短剧（PistyTV）移动应用程序（例如
          iOS 和 Android
          版本）（统称为“服务”）收集的个人信息，以及您的隐私权利。
        </p>

        <p>
          请注意，本政策仅适用于我们通过您使用服务收集或接收的信息。本政策不适用于第三方的行为、其网站内容、其对您提供给他们的信息的使用，或其可能提供的任何产品或服务，我们对此不承担任何责任。任何指向此类网站的链接均不构成我们对这些个人或公司的赞助、认可或关联关系。
        </p>

        <p>
          通过使用服务，您承认您已阅读并理解本政策，并同意按照此处所述处理您的个人信息。
        </p>

        <p>
          如果您对本政策有任何疑问，或者您的疑虑未在此处得到解决，请通过电子邮件联系我们：magicubegroup@gmail.com。
        </p>

        <p>我们从您那里收集的或关于您的信息</p>

        <p>
          我们收集您的信息，如下所述。正如以下章节进一步详述，我们将使用（并在某些情况下整合）这些信息，以运营、定制内容、个性化、调整和改进我们的服务，以及向您发送有关我们移动应用程序、新功能等的消息或个性化信息（包括基于您偏好的促销信息）。
        </p>

        <p>
          自动收集的信息：当您与我们的服务互动或使用我们的服务时，我们会自动收集有关您的设备以及您对我们服务的使用情况的某些信息。这可能包括您的语言、IP
          地址、设备
          ID、硬件和软件信息、标准服务器日志信息以及购买历史记录等数据。
        </p>

        <p>有关如何更改这些设置的更多信息，请访问：</p>
        <ul>
          <li>苹果：http://support.apple.com/kb/HT4228</li>
          <li>安卓系统：https://support.google.com/ads/answer/26629228</li>
        </ul>

        <p><strong>我们如何披露您的信息</strong></p>

        <p>
          除非我们获得您的同意或本政策另有规定，否则我们不会共享您的个人信息。我们可能会在以下情况下披露您的信息：
        </p>

        <p>
          <strong>为保护我们或他人而作出的披露：</strong>我们可能会根据法律要求披露您的信息，例如遵守传票或我们认为披露对于遵守法律而言是必要的；调查欺诈行为、响应政府要求、执行或运用我们的权利；或保护我们自己、我们的用户或他人的权利、财产和安全。这包括与其他公司和组织交换信息以防范欺诈。
        </p>
        <ul>
          <li>
            <strong>合并、出售或资产转让时的披露： </strong>
            如果我们发生任何合并、资产出售或融资，或者我们的业务被其他公司全部或部分收购，我们可能会共享您的信息。我们将通过电子邮件和/或通过我们服务上的通知，告知您有关您个人信息所有权或使用方式的任何变更。
          </li>
          <li>
            <strong>附属公司：</strong>
            我们可能会与我们的附属公司共享个人信息。
          </li>
        </ul>
        <p>
          <strong>其他重要信息</strong>
        </p>
        <p>
          <strong>政策变化：</strong>
        </p>
        <p>
          我们可能会定期更新本政策，以反映我们信息实践的变化。如果我们做出任何重大变更，我们将在变更生效前通过电子邮件（发送至您帐户中指定的电子邮件地址）或服务上的通知通知您。如果适用的数据保护法律要求我们提供更详细的通知或就任何此类变更征得您的同意，我们将照做。您可以查看本政策顶部显示的“上次更新”日期，了解本政策的上次更新时间。我们建议您定期查看此页面，以获取有关我们隐私实践的最新信息。
        </p>
        <p><strong>安全</strong></p>
        <p>
          我们采取合理适当的措施保护您的信息免遭第三方未经授权的访问、丢失、滥用或更改。
          尽管我们竭尽全力将通过服务收集的信息存储在安全的、不可公开访问的运行环境中，但我们无法保证这些信息在我们的系统中传输或存储时绝对安全。此外，尽管我们努力维护网络和系统的完整性和安全性，但我们无法保证我们的安全措施能够阻止第三方非法获取这些信息。我们不保证或声明您的信息将受到保护，免遭第三方丢失、滥用或篡改。然而，没有任何一种互联网传输或电子存储方法是
          100% 安全的。因此，我们无法保证其绝对安全。
        </p>
        <p><strong>数据保留</strong></p>
        <p>
          我们将在为您提供服务所需的时间内保留您的信息。如果您希望我们停止使用您的信息提供服务，请通过
          magicubegroup@gmail.com
          与我们联系。尽管有上述规定，我们仍将根据需要保留和使用您的信息，以履行我们的法律义务、解决争议并执行我们的协议。
        </p>
        <p><strong>我们的儿童政策</strong></p>
        <p>
          我们不会故意收集或索取 13
          岁以下（或您所在司法管辖区规定的成年年龄）儿童的个人信息，也不会故意允许儿童使用我们的服务。如果您未满
          13
          岁（或您所在司法管辖区规定的成年年龄），请勿发送任何关于您自己的信息，包括您的姓名、地址、电话号码或电子邮件地址。13
          岁以下的任何人均不得提供任何个人信息。如果您认为我们收集了儿童的个人信息，请使用以下联系方式与我们联系。如果我们得知我们收集了儿童的个人信息，我们将在商业可行的情况下尽快删除该信息。
        </p>

        <p><strong>您的隐私选择</strong></p>
        <p><strong>您对所提供信息的选择</strong></p>
        <p>
          如果您不想向我们提供个人信息，您可以选择不提供。如果您选择不向我们提供个人信息，我们可能无法始终提供您所需的服务。
        </p>

        <p><strong>您对向第三方提供信息的选择</strong></p>
        <p>您对向第三方提供信息的选择</p>

        <p><strong>访问和删除您的信息</strong></p>
        <p>
          您可以通过 magicubegroup@gmail.com
          联系我们以停用您的帐户或删除与您的帐户关联的电子邮件。
          如果您想访问或查看我们持有的关于您的个人信息，或者您因任何原因担心我们如何使用您的个人信息，或者想更正或要求我们删除此类个人信息，您也可以将您的请求发送至
          magicubegroup@gmail.com。
          如果您是加利福尼亚州居民或来自欧洲经济区（“EEA”）、英国或瑞士的用户，并且想要了解有关您的个人信息权利的更多信息，请参阅下面的相关部分。
        </p>

        <p><strong>加州居民补充信息</strong></p>
        <p>
          如果您是加利福尼亚州居民，则以下信息适用于您，并补充本政策中概述的有关您使用我们服务的信息。
        </p>

        <p><strong>我们收集的信息和信息来源：</strong></p>
        <p>
          我们的政策已描述我们收集的信息及其来源——请参阅上文“我们从您处收集的或关于您的信息”部分。本部分根据《加州消费者隐私法案》（“CCPA”）中规定的个人信息类别整理这些信息。
        </p>

        <p>我们收集了以下信息用于以下目的：</p>

        <ul>
          <li>
            <strong>标识符：</strong>例如，互联网协议地址、唯一个人标识符、账户用户名或屏幕名称。我们会在您提供给我们时或在您与我们的服务互动时自动获取这些信息。
          </li>
          <li>
            <strong>互联网或其他电子网络活动信息：</strong>例如，浏览器类型和语言、设备和硬件信息、游戏数据以及与您与我们服务互动相关的其他信息。当您与我们的服务互动时，我们会自动收集此类信息。
          </li>
          <li>
            <strong>人口统计信息/受保护特征：</strong>例如年龄和性别。我们会在您向我们提供这些信息时获取这些信息，或在您与我们的服务互动时自动获取这些信息。
          </li>
          <li>
            <strong>商业信息：</strong>包括购买或考虑的产品记录，或其他类似的消费历史或倾向。这使我们能够提供技术功能、开发新产品和服务，并分析您的使用情况。我们会直接从您那里收集此类信息，或在您与我们的服务互动时自动收集此类信息。
          </li>
        </ul>

        <p><strong>我们如何使用和共享信息</strong></p>
        <p>
          我们收集和使用个人信息用于商业目的，如上文“我们如何使用信息”部分所述。
        </p>
        <p>
          除非您同意或本政策另有规定，否则我们不会共享您的个人信息。您可以在上文“我们如何披露您的信息”部分了解更多信息。
        </p>
        <p>我们已出于商业目的披露以下类别的个人信息：</p>
        <ul>
          <li>标识符：如上所述。</li>
          <li>互联网或其他电子网络活动信息：如上所述。</li>
          <li>人口统计信息/受保护特征：如上所述。</li>
          <li>商业信息：如上所述。</li>
          <li>地理位置数据：如上所述。</li>
          <li>概况和推论：如上所述。</li>
        </ul>
        <p>
          我们不会出售用户的个人信息。但是，我们允许某些第三方广告和分析合作伙伴通过我们的服务收集消费者信息，以便投放更相关的广告、评估和分析广告活动，以及进行广告欺诈检测和报告。我们的合作伙伴收集的信息包括
          GAID（Android 设备上的 Google 广告 ID）或 IDFA（iOS
          设备上的广告商标识符）、地区（即使用特定语言的地区）、IP
          地址。如需了解更多信息或选择拒绝将您的数据用于广告目的，请参阅上文“基于兴趣的广告”部分。
        </p>

        <p><strong>您的隐私权利</strong></p>
        <p>根据 CCPA，加州居民享有以下权利：</p>
        <ul>
          <li>
            <strong>知情权：</strong>您有权要求我们披露过去 12
            个月内收集、使用和共享的个人信息，以及有关我们数据实践的信息。
          </li>
          <li>
            <strong>请求删除的权利：</strong>您有权要求我们删除我们从您那里收集的个人信息。
          </li>
          <li>
            <strong>不受歧视的权利：</strong>我们不会因您行使任何这些权利而歧视您。
          </li>
          <li>
            <strong>选择退出出售个人信息的权利：</strong>我们不出售个人信息，因此我们没有选择退出的权利。
          </li>
          <li>
            <strong>财务激励通知权：</strong>您有权了解任何财务激励优惠及其主要条款，并有权随时选择退出此类激励。我们目前不提供任何此类激励。
          </li>
        </ul>
        <p>
          加州法律还允许您请求获取某些信息，这些信息涉及我们及我们的关联公司出于直接营销目的向第三方披露您的个人信息。我们不会将您的个人信息披露给第三方用于其直接营销目的。
        </p>
        <p>
          要行使上述任何权利，或者如果您是根据 CCPA
          代表加州居民行使权利的授权代理人，您可以发送电子邮件至
          <strong>magicubegroup@gmail.com</strong> 或通过以下地址与我们联系。
        </p>
        <p>
          请注意，为了保护您的信息，我们可能需要在处理您的请求之前验证您的身份。在某些情况下，我们可能需要收集其他信息来验证您的身份，例如政府签发的身份证件。
        </p>
        <p>
          根据《加州消费者隐私法》(CCPA)，您可以自行行使这些权利，也可以授权代理人代您行使。我们可能需要您提供书面同意，以便授权代理人代表您提交请求，并且可能需要验证代理人的身份。
        </p>
        <p>
          如果您想了解有关我们的隐私惯例的更多信息，您可以发送电子邮件至
          <strong>magicubegroup@gmail.com</strong>。
        </p>

        <p><strong>针对欧洲经济区 (EEA)、英国和瑞士用户的附加信息</strong></p>
        <p>
          如果您是欧洲经济区、英国或瑞士的居民，以下信息适用于您使用我们的服务时收集的个人数据。
        </p>

        <p><strong>数据控制者</strong></p>
        <p>Magicube Group Co., Limited 是您个人数据的数据控制者。</p>

        <p><strong>处理您的个人数据的法律依据</strong></p>
        <p>我们根据以下原则收集、使用和共享您的个人数据：</p>
        <ul>
          <li>
            <strong>同意：</strong>我们基于您的同意处理您的个人数据。例如，这包括提供：
            <ul>
              <li>有关我们服务的电子通信、直接电子邮件和调查；</li>
              <li>我们的移动应用程序中的定向广告；</li>
              <li>其他营销功能。</li>
            </ul>
          </li>
          <li>
            <strong>合法利益：</strong>我们基于合法利益处理您的个人数据，前提是这些利益不会凌驾于您与数据隐私相关的基本权利和自由之上。例如，这包括：
            <ul>
              <li>提供您所需的客户服务或技术支持；</li>
              <li>调试和改进我们当前和未来的服务；</li>
              <li>根据适用的营销偏好与您联系；</li>
              <li>建立、行使或辩护法律主张，或当法院行使其司法权时。</li>
            </ul>
          </li>
          <li>
            <strong>法律义务：</strong>我们还处理您的个人数据以履行我们的法律义务。
          </li>
        </ul>

        <p><strong>国际数据传输</strong></p>
        <p>
          我们收集的个人数据可能会被传输至美国或我们或我们的关联公司、合作伙伴或服务提供商设有设施或开展业务的任何其他国家/地区，并在这些国家/地区进行存储和处理。我们将确保个人数据在传输至第三国或国际组织时得到适当的保护。
        </p>

        <p><strong>您的隐私权利</strong></p>
        <p>您对您的个人数据拥有以下权利：</p>
        <ul>
          <li>
            <strong>访问、更正和删除权利：</strong>您有权查看、更正、更新或请求删除您的个人数据，如上文“访问和删除您的信息”部分所述。
          </li>
          <li>
            <strong>反对权：</strong>如果我们基于合法利益处理您的个人数据，您可以基于与您的具体情况相关的理由反对我们处理您的个人数据。例如，您可以控制我们向您发送的营销信息的级别，并且您有权随时要求我们停止发送营销信息。您可以使用上文“您的选择”部分中描述的方法。
          </li>
          <li>
            <strong>撤回同意权：</strong>如果我们基于您的同意处理您的个人数据，您有权随时撤回您对进一步使用您个人数据的同意。您可以使用上文“您的选择”部分中描述的方法更新您的营销偏好设置。
          </li>
          <li>
            <strong>数据可携带权：</strong>在某些情况下，您可以要求我们将您的个人数据传输或传送给另一个组织。
          </li>
        </ul>
        <p>
          对于上述每一项权利，您可以将您的请求发送至
          <strong>magicubegroup@gmail.com</strong> 或使用下面列出的联系信息。
        </p>
        <p>
          我们希望解决您对我们处理个人数据方式的任何疑虑。但是，如果您有未解决的疑虑，您也有权向相关的数据保护机构提出投诉。您可以向您居住国、工作地或您认为数据保护法被违反的地方的机构提出投诉。如需了解更多信息，请联系您当地的数据保护机构。如需欧洲经济区和瑞士数据保护机构的联系方式，请点击此处。
        </p>

        <p><strong>联系信息</strong></p>
        <p>如果您对此政策有任何疑问，请联系我们：</p>
        <p>
          <strong>魔方集团有限公司</strong><br>
          邮箱：<strong>magicubegroup@gmail.com</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  data() {
    return {

    }
  },
}
</script>

<style scoped lang="scss">
#app {
  background: #fff;
  padding: 80px 40px;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.page-wrapper {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 960px;
  width: 100%;
}

.title {
  font-size: 36px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

h2 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 32px 0 16px;
}

p,
li {
  color: #333;
  font-size: 16px;
  line-height: 1.8;
}

ul {
  padding-left: 24px;
  margin: 12px 0;
}

strong {
  color: #000;
}
</style>
